const AuthModule = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/AuthModule.vue");
const AuthPage = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/pages/AuthPage.vue");
const Login = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/pages/Login.vue");
const ForgotPassword = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/pages/ForgotPassword.vue");
const ResetPassword = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/pages/ResetPassword.vue");
const SignUp = () => import(/* webpackChunkName: 'auth' */ "@/modules/AuthModule/pages/SignUp.vue");
import auth from "../../packages/auth";

export const AuthRoutes = [
  {
    path: "/auth",
    component: AuthModule,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (auth.isAuthenticated()) {
        next({
          name: "dashboard.home"
        });
      } else {
        next();
      }
    },
    children: [
      {
        path: "/",
        name: "auth",
        component: AuthPage,
        redirect: { name: "auth.login" },
        children: [
          {
            path: "login",
            name: "auth.login",
            component: Login
          },
          {
            path: "forgot-password",
            name: "auth.forgot-password",
            component: ForgotPassword
          },
          {
            path: "reset-password/:reset",
            name: "auth.reset-password",
            component: ResetPassword,
            props: true
          }
        ]
      },
      {
        path: "signup",
        name: "auth.signup",
        component: SignUp
      }
    ]
  }
];
